export default "__VITE_ASSET__CK3$APrs__"